import { FormWithRedirect, TextInput, Toolbar } from "react-admin";
import { Box, Card, CardContent, Typography } from "@material-ui/core";
import * as React from "react";

const PbhRequestStatusInfoEditForm = props => {
  var cardStyle = {
    display: "block",
    width: "40vw",
    transitionDuration: "0.3s",
    height: "auto",
    marginLeft: "30px",
  };
  return (
    <FormWithRedirect
      {...props}
      render={(formProps: any) => (
        <Card variant="outlined" style={cardStyle}>
          <form>
            <CardContent>
              <Box display={{ sm: "block", md: "flex" }}>
                <Box flex={2}>
                  <Box mt="1em">
                    <Typography variant="h6" gutterBottom color="primary">
                      Updatable Field
                    </Typography>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <TextInput
                        source="displayName"
                        label="DISPLAY NAME"
                        multiline
                        required
                        fullWidth
                        minRows={4}
                        variant="outlined"
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </CardContent>
            <Toolbar
              {...props}
              placeholder=""
              record={formProps.record}
              basePath={formProps.basePath}
              undoable={true}
              invalid={formProps.invalid}
              handleSubmit={formProps.handleSubmit}
              saving={formProps.saving}
            />
          </form>
        </Card>
      )}
    />
  );
};

export default PbhRequestStatusInfoEditForm;
